module.exports = "<canvas #canvas [width]=\"width\" [height]=\"height\"></canvas>"